interface StatCardProps {
  label: string;
  value: string;
  hint?: string;
  trend?: { direction: 'up' | 'down' | 'neutral'; deltaText: string };
  onClick?: () => void;
  emphasis?: boolean;
}

export default function StatCard({ label, value, hint, trend, onClick, emphasis }: StatCardProps) {
  const trendColor =
    trend?.direction === 'up'
      ? 'text-green-600'
      : trend?.direction === 'down'
      ? 'text-red-600'
      : 'text-gray-500';
  const Component = onClick ? 'button' : 'div';
  return (
    <Component
      type={onClick ? 'button' : undefined}
      onClick={onClick}
      className={`rounded-xl bg-white p-4 ring-1 ring-inset ${
        emphasis ? 'ring-indigo-200 shadow-sm' : 'ring-gray-200'
      } ${onClick ? 'cursor-pointer text-left transition hover:bg-gray-50 hover:ring-indigo-200' : ''}`}
    >
      <dt className="text-xs font-medium uppercase tracking-wide text-gray-500">{label}</dt>
      <dd className="mt-1 font-mono text-xl font-semibold text-gray-900">{value}</dd>
      {(hint || trend) && (
        <dd className="mt-1 flex items-center gap-2 text-xs">
          {trend && <span className={trendColor}>{trend.deltaText}</span>}
          {hint && <span className="text-gray-500">{hint}</span>}
        </dd>
      )}
    </Component>
  );
}
